import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function BubleChartColor({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
            <path
                fill={color}
                d="M6.21 9.778C3.885 9.778 2 11.767 2 14.222c0 2.456 1.884 4.445 4.21 4.445 2.327 0 4.211-1.99 4.211-4.445s-1.884-4.444-4.21-4.444Zm0 6.666c-1.157 0-2.105-1-2.105-2.222S5.053 12 6.211 12c1.157 0 2.105 1 2.105 2.222s-.948 2.222-2.105 2.222Zm8.432-1.11c-1.737 0-3.158 1.5-3.158 3.333 0 1.833 1.421 3.333 3.158 3.333 1.737 0 3.158-1.5 3.158-3.333 0-1.834-1.421-3.334-3.158-3.334Zm0 4.444c-.579 0-1.053-.5-1.053-1.111s.474-1.111 1.053-1.111c.58 0 1.053.5 1.053 1.11 0 .612-.474 1.112-1.053 1.112ZM16.211 2c-3.19 0-5.79 2.744-5.79 6.111 0 3.367 2.6 6.111 5.79 6.111 3.189 0 5.789-2.744 5.789-6.11C22 4.743 19.4 2 16.21 2Zm0 10c-2.032 0-3.685-1.744-3.685-3.889 0-2.144 1.653-3.889 3.684-3.889 2.032 0 3.685 1.745 3.685 3.89 0 2.144-1.653 3.888-3.684 3.888Z"
            />
            <path
                fill="#198E59"
                fillRule="evenodd"
                d="M14.632 15.333c-1.737 0-3.158 1.5-3.158 3.334 0 1.833 1.42 3.333 3.158 3.333 1.736 0 3.158-1.5 3.158-3.333 0-1.834-1.422-3.334-3.158-3.334Zm0 4.445c-.58 0-1.053-.5-1.053-1.111s.474-1.111 1.053-1.111 1.052.5 1.052 1.11c0 .612-.473 1.112-1.052 1.112Z"
                clipRule="evenodd"
            />
            <path
                fill="#B3CFE5"
                fillRule="evenodd"
                d="M6.21 9.778C3.885 9.778 2 11.767 2 14.222c0 2.456 1.884 4.445 4.21 4.445 2.327 0 4.211-1.99 4.211-4.445s-1.884-4.444-4.21-4.444Zm0 6.666c-1.157 0-2.105-1-2.105-2.222S5.053 12 6.211 12c1.157 0 2.105 1 2.105 2.222s-.948 2.222-2.105 2.222Z"
                clipRule="evenodd"
            />
        </svg>
    );
}

export default BubleChartColor;
